import base from "./base";

//TODO change file name to base.ts to enable typescript
export default {
    getCustomers() {
        return base.get('customers')
    }
}